var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoPrototypes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 356,
    height: 240,
    viewBox: "0 0 356 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_928_21016)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.42 222.129H156.244L164.549 181.52H191.12L199.42 222.129Z",
    fill: "#93969A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.476 217.534H151.188C150.247 217.534 149.483 218.297 149.483 219.239V225.02C149.483 225.962 150.247 226.725 151.188 226.725H204.476C205.418 226.725 206.181 225.962 206.181 225.02V219.239C206.181 218.297 205.418 217.534 204.476 217.534Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.764 79.7954H97.9004C94.8939 79.7954 92.4565 82.2327 92.4565 85.2393V198.231C92.4565 201.237 94.8939 203.675 97.9004 203.675H257.764C260.771 203.675 263.208 201.237 263.208 198.231V85.2393C263.208 82.2327 260.771 79.7954 257.764 79.7954Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.01 85.6868H100.654C99.7127 85.6868 98.9492 86.4502 98.9492 87.392V183.067C98.9492 184.009 99.7127 184.772 100.654 184.772H255.01C255.952 184.772 256.715 184.009 256.715 183.067V87.392C256.715 86.4502 255.952 85.6868 255.01 85.6868Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.832 197.766C180.34 197.766 182.372 195.734 182.372 193.226C182.372 190.719 180.34 188.686 177.832 188.686C175.325 188.686 173.292 190.719 173.292 193.226C173.292 195.734 175.325 197.766 177.832 197.766Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.431 131.924L207.146 170.797C207.139 171.739 207.897 172.508 208.839 172.515L248.608 172.806C249.549 172.813 250.318 172.056 250.325 171.114L250.61 132.24C250.617 131.299 249.859 130.53 248.918 130.523L209.149 130.231C208.207 130.224 207.438 130.982 207.431 131.924Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.67 130.244H106.9C105.958 130.244 105.195 131.008 105.195 131.949V157.259C105.195 158.201 105.958 158.964 106.9 158.964H146.67C147.611 158.964 148.375 158.201 148.375 157.259V131.949C148.375 131.008 147.611 130.244 146.67 130.244Z",
    fill: "#93969A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.719 130.244H157.95C157.008 130.244 156.244 131.008 156.244 131.949V157.259C156.244 158.201 157.008 158.964 157.95 158.964H197.719C198.661 158.964 199.425 158.201 199.425 157.259V131.949C199.425 131.008 198.661 130.244 197.719 130.244Z",
    fill: "#93969A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.387 161.04H105.834C105.481 161.04 105.195 161.327 105.195 161.68V162.89C105.195 163.244 105.481 163.53 105.834 163.53H131.387C131.74 163.53 132.026 163.244 132.026 162.89V161.68C132.026 161.327 131.74 161.04 131.387 161.04Z",
    fill: "#93969A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.735 161.04H134.328C133.975 161.04 133.688 161.327 133.688 161.68V162.89C133.688 163.244 133.975 163.53 134.328 163.53H147.735C148.088 163.53 148.375 163.244 148.375 162.89V161.68C148.375 161.327 148.088 161.04 147.735 161.04Z",
    fill: "#93969A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.831 165.61H105.834C105.481 165.61 105.195 165.896 105.195 166.25V167.46C105.195 167.813 105.481 168.1 105.834 168.1H120.831C121.185 168.1 121.471 167.813 121.471 167.46V166.25C121.471 165.896 121.185 165.61 120.831 165.61Z",
    fill: "#93969A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.35 165.61H123.769C123.415 165.61 123.129 165.896 123.129 166.25V167.46C123.129 167.813 123.415 168.1 123.769 168.1H132.35C132.703 168.1 132.99 167.813 132.99 167.46V166.25C132.99 165.896 132.703 165.61 132.35 165.61Z",
    fill: "#93969A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.417 170.176H105.834C105.481 170.176 105.195 170.462 105.195 170.815V172.026C105.195 172.379 105.481 172.665 105.834 172.665H117.417C117.77 172.665 118.056 172.379 118.056 172.026V170.815C118.056 170.462 117.77 170.176 117.417 170.176Z",
    fill: "#93969A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.935 170.176H120.354C120.001 170.176 119.714 170.462 119.714 170.815V172.026C119.714 172.379 120.001 172.665 120.354 172.665H128.935C129.288 172.665 129.575 172.379 129.575 172.026V170.815C129.575 170.462 129.288 170.176 128.935 170.176Z",
    fill: "#93969A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.869 165.61H135.287C134.934 165.61 134.648 165.896 134.648 166.25V167.46C134.648 167.813 134.934 168.1 135.287 168.1H143.869C144.222 168.1 144.508 167.813 144.508 167.46V166.25C144.508 165.896 144.222 165.61 143.869 165.61Z",
    fill: "#93969A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.769 97.3762H106.9C105.958 97.3762 105.195 98.1397 105.195 99.0814V119.57C105.195 120.511 105.958 121.275 106.9 121.275H248.769C249.711 121.275 250.474 120.511 250.474 119.57V99.0814C250.474 98.1397 249.711 97.3762 248.769 97.3762Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.436 161.04H156.884C156.531 161.04 156.244 161.327 156.244 161.68V162.89C156.244 163.244 156.531 163.53 156.884 163.53H182.436C182.79 163.53 183.076 163.244 183.076 162.89V161.68C183.076 161.327 182.79 161.04 182.436 161.04Z",
    fill: "#93969A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.785 161.04H185.378C185.025 161.04 184.738 161.327 184.738 161.68V162.89C184.738 163.244 185.025 163.53 185.378 163.53H198.785C199.138 163.53 199.424 163.244 199.424 162.89V161.68C199.424 161.327 199.138 161.04 198.785 161.04Z",
    fill: "#93969A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.881 165.61H156.884C156.531 165.61 156.244 165.896 156.244 166.25V167.46C156.244 167.813 156.531 168.1 156.884 168.1H171.881C172.234 168.1 172.521 167.813 172.521 167.46V166.25C172.521 165.896 172.234 165.61 171.881 165.61Z",
    fill: "#93969A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.4 165.61H174.818C174.465 165.61 174.179 165.896 174.179 166.25V167.46C174.179 167.813 174.465 168.1 174.818 168.1H183.4C183.753 168.1 184.039 167.813 184.039 167.46V166.25C184.039 165.896 183.753 165.61 183.4 165.61Z",
    fill: "#93969A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.466 170.176H156.884C156.531 170.176 156.244 170.462 156.244 170.815V172.026C156.244 172.379 156.531 172.665 156.884 172.665H168.466C168.82 172.665 169.106 172.379 169.106 172.026V170.815C169.106 170.462 168.82 170.176 168.466 170.176Z",
    fill: "#93969A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.985 170.176H171.404C171.05 170.176 170.764 170.462 170.764 170.815V172.026C170.764 172.379 171.05 172.665 171.404 172.665H179.985C180.338 172.665 180.625 172.379 180.625 172.026V170.815C180.625 170.462 180.338 170.176 179.985 170.176Z",
    fill: "#93969A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.918 165.61H186.337C185.984 165.61 185.698 165.896 185.698 166.25V167.46C185.698 167.813 185.984 168.1 186.337 168.1H194.918C195.272 168.1 195.558 167.813 195.558 167.46V166.25C195.558 165.896 195.272 165.61 194.918 165.61Z",
    fill: "#93969A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.665 226.725H0V239.996H355.665V226.725Z",
    fill: "#93969A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.229 226.729H274.897V221.788C274.897 220.045 276.312 218.629 278.056 218.629H321.074C322.818 218.629 324.233 220.045 324.233 221.788V226.729H324.229Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.626 219.401H283.5V218.054C283.5 216.31 284.915 214.895 286.659 214.895H312.471C314.215 214.895 315.63 216.31 315.63 218.054V219.401H315.626Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.982 110.178H234.424V103.873C234.424 103.464 234.091 103.131 233.682 103.131H223.314C222.905 103.131 222.573 103.464 222.573 103.873V110.178H220.015V103.873C220.015 102.053 221.494 100.573 223.314 100.573H233.682C235.502 100.573 236.982 102.053 236.982 103.873V110.178Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.722 127.794L243.183 128.01C244.125 128.017 244.894 127.26 244.901 126.318L245.036 107.864C245.043 106.922 244.285 106.153 243.343 106.146L213.882 105.93C212.941 105.923 212.172 106.681 212.165 107.623L212.029 126.077C212.022 127.019 212.78 127.788 213.722 127.794Z",
    fill: "#93969A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.919 131.474L244.375 131.617C244.644 131.619 244.863 131.403 244.865 131.135L244.872 130.21C244.874 129.941 244.658 129.722 244.389 129.72L224.933 129.577C224.665 129.575 224.446 129.791 224.444 130.06L224.437 130.985C224.435 131.253 224.651 131.472 224.919 131.474Z",
    fill: "#93969A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.474 131.378L222.684 131.452C222.952 131.454 223.171 131.238 223.173 130.97L223.18 130.045C223.182 129.777 222.966 129.557 222.698 129.555L212.488 129.481C212.22 129.479 212 129.695 211.998 129.963L211.992 130.888C211.99 131.157 212.206 131.376 212.474 131.378Z",
    fill: "#93969A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.93 135.009L244.35 135.092C244.618 135.094 244.838 134.878 244.839 134.61L244.846 133.685C244.848 133.417 244.632 133.197 244.364 133.195L232.944 133.112C232.675 133.11 232.456 133.326 232.454 133.594L232.447 134.519C232.445 134.788 232.661 135.007 232.93 135.009Z",
    fill: "#93969A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.16 134.942L230.695 134.99C230.963 134.992 231.182 134.776 231.184 134.508L231.191 133.583C231.193 133.314 230.977 133.095 230.709 133.093L224.174 133.045C223.905 133.043 223.686 133.259 223.684 133.528L223.677 134.453C223.675 134.721 223.891 134.94 224.16 134.942Z",
    fill: "#93969A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.505 138.5L244.325 138.565C244.593 138.567 244.812 138.351 244.814 138.083L244.821 137.158C244.823 136.889 244.607 136.67 244.338 136.668L235.519 136.603C235.25 136.601 235.031 136.817 235.029 137.086L235.022 138.011C235.02 138.279 235.236 138.498 235.505 138.5Z",
    fill: "#93969A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.735 138.436L233.27 138.484C233.538 138.486 233.757 138.27 233.759 138.002L233.766 137.077C233.768 136.808 233.552 136.589 233.284 136.587L226.749 136.539C226.48 136.537 226.261 136.753 226.259 137.022L226.252 137.947C226.25 138.215 226.466 138.434 226.735 138.436Z",
    fill: "#93969A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.39 134.875L221.925 134.922C222.193 134.924 222.412 134.708 222.414 134.44L222.421 133.515C222.423 133.247 222.207 133.027 221.939 133.025L215.404 132.978C215.135 132.976 214.916 133.192 214.914 133.46L214.907 134.385C214.905 134.653 215.121 134.873 215.39 134.875Z",
    fill: "#93969A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.777 30.1353H227.219V101.852H229.777V30.1353Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.362 11.4675V212.763H290.764V11.4675H308.362ZM310.92 8.90967H288.206V215.321H310.92V8.90967Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.362 191.225L288.554 193.034L308.759 213.24L310.568 211.431L290.362 191.225Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.762 191.225L288.557 211.431L290.365 213.24L310.571 193.034L308.762 191.225Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.367 171.019L288.558 172.827L308.764 193.033L310.572 191.224L290.367 171.019Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.764 171.02L288.558 191.226L290.367 193.034L310.572 172.829L308.764 171.02Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.364 150.813L288.555 152.622L308.761 172.827L310.569 171.019L290.364 150.813Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.761 150.81L288.555 171.016L290.364 172.825L310.569 152.619L308.761 150.81Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.368 130.611L288.56 132.419L308.765 152.625L310.574 150.816L290.368 130.611Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.765 130.608L288.56 150.813L290.368 152.622L310.574 132.417L308.765 130.608Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.365 110.405L288.557 112.214L308.762 132.42L310.571 130.611L290.365 110.405Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.762 110.403L288.557 130.608L290.365 132.417L310.571 112.211L308.762 110.403Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.362 90.2001L288.554 92.0088L308.759 112.214L310.568 110.406L290.362 90.2001Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.762 90.2001L288.557 110.406L290.365 112.214L310.571 92.0088L308.762 90.2001Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.367 69.9934L288.558 71.802L308.764 92.0076L310.572 90.199L290.367 69.9934Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.764 69.9946L288.558 90.2002L290.367 92.0088L310.572 71.8032L308.764 69.9946Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.364 49.788L288.555 51.5967L308.761 71.8023L310.569 69.9937L290.364 49.788Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.764 49.788L288.558 69.9937L290.367 71.8023L310.572 51.5967L308.764 49.788Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.364 29.5856L288.555 31.3943L308.761 51.5999L310.569 49.7913L290.364 29.5856Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.761 29.5825L288.555 49.7881L290.364 51.5967L310.569 31.3911L308.761 29.5825Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.365 9.38007L288.556 11.1887L308.762 31.3944L310.571 29.5857L290.365 9.38007Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.765 9.38007L288.56 29.5857L290.368 31.3943L310.574 11.1887L308.765 9.38007Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.263 29.2102H288.859V31.768H310.263V29.2102Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.263 49.417H288.859V51.9748H310.263V49.417Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.263 69.6196H288.859V72.1774H310.263V69.6196Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.263 89.8262H288.859V92.384H310.263V89.8262Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.263 110.033H288.859V112.591H310.263V110.033Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.263 130.236H288.859V132.793H310.263V130.236Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.263 150.442H288.859V153H310.263V150.442Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.263 170.645H288.859V173.203H310.263V170.645Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.263 190.852H288.859V193.409H310.263V190.852Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.362 11.4675V212.763H290.764V11.4675H308.362ZM310.92 8.90967H288.206V215.321H310.92V8.90967Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.362 191.225L288.554 193.034L308.759 213.24L310.568 211.431L290.362 191.225Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.762 191.225L288.557 211.431L290.365 213.24L310.571 193.034L308.762 191.225Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.367 171.019L288.558 172.827L308.764 193.033L310.572 191.224L290.367 171.019Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.764 171.02L288.558 191.226L290.367 193.034L310.572 172.829L308.764 171.02Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.364 150.813L288.555 152.622L308.761 172.827L310.569 171.019L290.364 150.813Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.761 150.81L288.555 171.016L290.364 172.825L310.569 152.619L308.761 150.81Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.368 130.611L288.56 132.419L308.765 152.625L310.574 150.816L290.368 130.611Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.765 130.608L288.56 150.813L290.368 152.622L310.574 132.417L308.765 130.608Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.365 110.405L288.557 112.214L308.762 132.42L310.571 130.611L290.365 110.405Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.762 110.403L288.557 130.608L290.365 132.417L310.571 112.211L308.762 110.403Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.362 90.2001L288.554 92.0088L308.759 112.214L310.568 110.406L290.362 90.2001Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.762 90.2001L288.557 110.406L290.365 112.214L310.571 92.0088L308.762 90.2001Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.367 69.9934L288.558 71.802L308.764 92.0076L310.572 90.199L290.367 69.9934Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.764 69.9946L288.558 90.2002L290.367 92.0088L310.572 71.8032L308.764 69.9946Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.364 49.788L288.555 51.5967L308.761 71.8023L310.569 69.9937L290.364 49.788Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.764 49.788L288.558 69.9937L290.367 71.8023L310.572 51.5967L308.764 49.788Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.364 29.5856L288.555 31.3943L308.761 51.5999L310.569 49.7913L290.364 29.5856Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.761 29.5825L288.555 49.7881L290.364 51.5967L310.569 31.3911L308.761 29.5825Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.365 9.38007L288.556 11.1887L308.762 31.3944L310.571 29.5857L290.365 9.38007Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.765 9.38007L288.56 29.5857L290.368 31.3943L310.574 11.1887L308.765 9.38007Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.263 29.2102H288.859V31.768H310.263V29.2102Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.263 49.417H288.859V51.9748H310.263V49.417Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.263 69.6196H288.859V72.1774H310.263V69.6196Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.263 89.8262H288.859V92.384H310.263V89.8262Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.263 110.033H288.859V112.591H310.263V110.033Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.263 130.236H288.859V132.793H310.263V130.236Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.263 150.442H288.859V153H310.263V150.442Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.263 170.645H288.859V173.203H310.263V170.645Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.263 190.852H288.859V193.409H310.263V190.852Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.004 11.4675V29.0653H212.491L229.935 11.4675H329.004ZM331.561 8.90967H228.869L206.356 31.6231H331.561V8.90967Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.005 9.27568L308.796 29.4778L310.604 31.2867L330.814 11.0846L329.005 9.27568Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.599 9.25898L308.791 11.0676L328.996 31.2733L330.805 29.4646L310.599 9.25898Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.79 9.25749L288.584 29.4631L290.393 31.2718L310.598 11.0661L308.79 9.25749Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.39 9.25751L288.581 11.0662L308.787 31.2718L310.595 29.4631L290.39 9.25751Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.584 9.26042L268.378 29.4661L270.187 31.2747L290.393 11.0691L288.584 9.26042Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.184 9.26044L268.375 11.0691L288.581 31.2747L290.39 29.4661L270.184 9.26044Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.375 9.25922L248.169 29.4648L249.978 31.2735L270.183 11.0679L268.375 9.25922Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.978 9.25605L248.169 11.0647L268.375 31.2703L270.183 29.4617L249.978 9.25605Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.172 9.25896L227.967 29.4646L229.775 31.2732L249.981 11.0676L248.172 9.25896Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.772 9.25898L227.963 11.0676L248.169 31.2733L249.978 29.4646L229.772 9.25898Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.148 11.3738H227.59V30.9667H230.148V11.3738Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.355 9.56201H247.797V30.9667H250.355V9.56201Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.562 9.56201H268.004V30.9667H270.562V9.56201Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.485 30.9666L289.46 34.6967H213.365V30.9666H289.485Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.971 9.56201H308.413V30.9667H310.971V9.56201Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.174 9.56201H328.616V30.9667H331.174V9.56201Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.971 5.01343H288.206V36.3765H310.971V5.01343Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.135 0V42.3447H315.388V0H284.135ZM310.17 34.0318H289.012V6.28797H310.17V34.0318Z",
    fill: "#93969A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9923 123.947V224.167H53.3945V123.947H70.9923ZM73.5501 121.39H50.8367V226.725H73.5501V121.39Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9962 202.632L51.1875 204.44L71.3931 224.646L73.2018 222.837L52.9962 202.632Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3931 202.635L51.1875 222.84L52.9962 224.649L73.2018 204.443L71.3931 202.635Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9962 182.429L51.1875 184.238L71.3931 204.443L73.2018 202.635L52.9962 182.429Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3902 182.429L51.1846 202.635L52.9932 204.443L73.1989 184.238L71.3902 182.429Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9932 162.224L51.1846 164.032L71.3902 184.238L73.1989 182.429L52.9932 162.224Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3873 162.224L51.1816 182.429L52.9903 184.238L73.1959 164.032L71.3873 162.224Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9944 142.014L51.1858 143.823L71.3914 164.028L73.2001 162.22L52.9944 142.014Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3914 142.017L51.1858 162.223L52.9944 164.032L73.2001 143.826L71.3914 142.017Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9947 121.812L51.186 123.62L71.3917 143.826L73.2003 142.017L52.9947 121.812Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3885 121.812L51.1829 142.017L52.9915 143.826L73.1971 123.62L71.3885 121.812Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8934 121.441H51.4888V123.999H72.8934V121.441Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8934 141.643H51.4888V144.201H72.8934V141.643Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8934 161.85H51.4888V164.408H72.8934V161.85Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8934 182.053H51.4888V184.611H72.8934V182.053Z",
    fill: "#3A3E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8934 202.26H51.4888V204.817H72.8934V202.26Z",
    fill: "#3A3E47"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_928_21016"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 355.665,
    height: 240,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPrototypes);
export default __webpack_public_path__ + "static/media/NoPrototypes.ed43b9e5228b2adddee9758692b171e2.svg";
export { ForwardRef as ReactComponent };